/* eslint-disable import/no-cycle */
import { Validator } from 'vee-validate';
import IAddress from '@/models/interfaces/IAddress';
import RegexExpressions from '@/RegexExpressions';
import { store } from '../store';

class ValidationService {
  private static serviceInstance: ValidationService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public getValidationClass(
    validator: Validator,
    fieldName: string,
    fieldType: string = 'input',
    fieldChanged: boolean = false,
    initial: boolean = false,
    validationScope: string = ''
  ): string {
    const field = validator.fields.find({ name: fieldName });

    if (field) {
      if (field.flags.valid) {
        return `tla-form-group__${fieldType}--success`;
      }

      const hideError: boolean = !field.flags.touched && !initial && !fieldChanged;

      if (hideError && !this.hasNextBeenClicked(validationScope)) {
        return '';
      }

      return `tla-form-group__${fieldType}--error`;
    }

    return '';
  }

  public hasNextBeenClicked(validationScope: string): boolean {
    if (validationScope === null) {
      return false;
    }

    const isEnabled = store.getters['initialSettingsModule/showErrorsOnNext'];

    if (validationScope.length === 0 || !isEnabled) {
      return false;
    }

    const clickedScopes: string[] = store.getters['enquiryModule/nextButtonsClicked'];

    const isClicked = clickedScopes.includes(validationScope);

    return isClicked;
  }

  public isVehicleLevelDataSet(key: string): boolean {
    return store.getters[`vehicleModule${key}/isVehicleLevelDataSet`];
  }

  public isEnquiryServicesDataSet(): boolean {
    return !(store.getters['enquiryModule/enquiryChoicesContainsErrors']);
  }

  public isVehicleCustomisationDataSet(): boolean {
    return store.getters['vehicleModule/isVehicleCustomisationDataSet'];
  }

  public isDQVehicleCustomisationDataSet(): boolean {
    return store.getters['vehicleModule/isDQVehicleCustomisationDataSet'];
  }

  public isDQVehicleCustomisationBDataSet(): boolean {
    return store.getters['vehicleModule/isDQVehicleCustomisationBDataSet'];
  }

  public isRegistrationLookupDataSet(): boolean {
    return store.getters['vehicleValuationModule/isRegistrationLookupDataSet'];
  }

  public isValidTestDriveSlot(): boolean {
    return store.getters['testDriveAvailabilityModule/isValidTestDriveSlot'];
  }

  public isBuildingNameNumberValid(): boolean {
    const address: IAddress = store.getters['addressModule/address'];

    if (address) {
      return address.buildingName.length > 0 || address.buildingNumber.length > 0;
    }

    return false;
  }

  public isStreetValid(): boolean {
    const address: IAddress = store.getters['addressModule/address'];

    if (address) {
      if (address.street.length === 0) {
        return address.buildingName.length > 0;
      }

      return address.street.length > 0;
    }

    return false;
  }

  // PostCode validation for UK Postcode
  public isPostcodeValid(postcode: string): boolean {
    const REGEX = RegExp(RegexExpressions.POST_CODE);

    return REGEX.test(postcode);
  }

  public formattedDate(contractStartDateString: string): Promise<Date> {
    const formattedDate = new Date(0);
    const dateArray = contractStartDateString.split('.');
    const utcString = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
    formattedDate.setUTCMilliseconds(Date.parse(utcString));

    return new Promise((resolve) => {
      resolve(formattedDate);
    });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const validationService = ValidationService.instance;
